import { render, staticRenderFns } from "./irrelevantManageCom.vue?vue&type=template&id=083e767c&scoped=true"
import script from "./irrelevantManageCom.vue?vue&type=script&lang=js"
export * from "./irrelevantManageCom.vue?vue&type=script&lang=js"
import style0 from "./irrelevantManageCom.vue?vue&type=style&index=0&id=083e767c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e767c",
  null
  
)

export default component.exports